import React from 'react';
import { render } from 'react-dom';

import { MaintenanceInfo } from '@neptune/maintenance-info-feature';

export function renderMaintenanceInfo() {
  render(<MaintenanceInfo />, document.getElementById('maintenance-app'));
}
